import { render, staticRenderFns } from "./basicinfo.vue?vue&type=template&id=96e34e62"
import script from "./basicinfo.vue?vue&type=script&lang=js"
export * from "./basicinfo.vue?vue&type=script&lang=js"
import style0 from "./basicinfo.vue?vue&type=style&index=0&id=96e34e62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports